<!--
 * @Author: your name
 * @Date: 2020-10-22 14:02:44
 * @LastEditTime: 2021-11-26 14:28:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/App.vue
-->
<template>
  <div id="app">
    <Layout v-if="$route.meta.requiresAuth">
      <router-view></router-view>
    </Layout>
    <router-view v-if="$route.name ==='AppDownload'"></router-view>
  </div>
</template>
<script>
// @ is an alias to /src
import Layout from './layout/Layout'
import {mapActions,mapGetters} from 'vuex'
export default {
  components: {
    Layout
  },
  computed: {
  },
  methods: {
    ...mapActions(['getDicOptionList', 'getAreaList'])
  },
  watch: {
  },
  mounted () {
    this.getDicOptionList()
    this.getAreaList()
  }
};
</script>

<style lang="scss">
  @import "./styles/index";
  #app {
    height: 100%;
    max-width: 1920px;
    margin: 0 auto;
  }
</style>
